/* eslint-disable camelcase */
import { formatDate } from 'Components/frameworks/datepicker/Datepicker.utils';
import { computePriceInCents } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater.utils';

const trackUplift = ({
  orderId,
  isErrored,
  errorMsg,
}: {
  orderId: string;
  isErrored: boolean;
  errorMsg: string;
}) => {
  if (isErrored) {
    window.Uplift.Payments.error(errorMsg, 'fatal');
  } else {
    window.Uplift.Analytics.orderResponse({
      mode_of_payment: 'pay monthly',
      order_id: orderId,
    });
    window.Uplift.Payments.confirm(orderId);
  }
};

const buildOrder = ({
  price,
  accommodations,
  departureDate,
  arrivalDate,
  name,
  attendees,
  transports,
}) => {
  const mappedAttendees = (attendees || []).map(
    (
      {
        firstName,
        lastName,
        email,
        mobilePhoneNumber,
        dateOfBirth,
        birthday,
        address: { city, countryCode, stateOrDistrict, streetName, streetNumber, zipCode } = {},
      },
      index,
    ) => ({
      id: index,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: mobilePhoneNumber,
      date_of_birth: formatDate(dateOfBirth || birthday, 'MM/DD/YYYY'),
      street_address: streetName && `${streetNumber} ${streetName}`,
      city,
      region: stateOrDistrict,
      country: countryCode,
      postal_code: zipCode,
    }),
  );

  const billing_contact = mappedAttendees[0];
  const travelers = mappedAttendees.map(({ id, first_name, last_name, date_of_birth }) => ({
    id,
    first_name,
    last_name,
    date_of_birth,
  }));

  let air_reservations = [];

  if (transports?.length) {
    const inboundTransport = transports?.[0] || [];
    const { company, origin } = inboundTransport[0];
    const { destination } = inboundTransport[inboundTransport.length - 1];

    air_reservations = [
      {
        airline_name: company.name,
        origin,
        destination,
        trip_type: 'roundtrip',
        itinerary: transports
          .flat()
          .map(({ departure, arrival, company: { id: carrier_code } }) => ({
            departure_apc: departure.apc,
            departure_time: departure.date,
            arrival_apc: arrival.apc,
            arrival_time: arrival.date,
            fare_class: 'Economy',
            carrier_code,
          })),
        insurance: [],
      },
    ];
  }

  return {
    order_amount: computePriceInCents(price || 0),
    travelers,
    add_ons: [],
    billing_contact,
    air_reservations,
    hotel_reservations: [
      {
        hotel_name: name,
        number_of_rooms: accommodations?.count || 1,
        room_type: accommodations?.name || '',
        check_in: departureDate,
        check_out: arrivalDate,
      },
    ],
  };
};

export { trackUplift, buildOrder };
